import { ReactNode, useCallback, useState } from 'react'

import PlainModal, {
  PlainModalHeader,
  HandleModalDisplayed,
  PlainModalContent,
  PlainModalFooter,
} from 'app/common/ui-next/plain-modal'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { useSaleTypesData } from 'app/dataProviders/SaleTypesData'
import usePopup from 'app/common/hooks/usePopup'

import { EditProductionTypeForm, FormControl } from './EditProductionTypeForm'


type Props = {
  saleTypeId: string
  children: (toggle: HandleModalDisplayed) => ReactNode
}

export const EditProductionTypeModal = ({ children, saleTypeId }: Props) => {
  const [submitting, setSubmitting] = useState(false)
  const [modify, setModify] = useState(false)

  const { saleTypesState, modifySaleType } = useSaleTypesData()
  const saleTypeTarget = saleTypesState[saleTypeId]

  const popup = usePopup()

  const handleSubmit = useCallback(async (form: HTMLFormElement) => {
    setSubmitting(true)
    const formData = new FormData(form)
    const title = formData.get(FormControl.Name) as string
    const res = await modifySaleType({ title, id: saleTypeId })
    setSubmitting(false)
    if (res) popup('Тип продукции успешно изменен')
    return !!res
  }, [saleTypeId, modifySaleType, popup])

  const handleChangeModalDisplayed = useCallback((displayed: boolean) => {
    if (!displayed) {
      setModify(false)
    }
  }, [])

  return (
    <PlainModal
      formId="editProductionType"
      controlBy={children}
      onSubmit={handleSubmit}
      onDisplayStatusChange={handleChangeModalDisplayed}
    >
      <PlainModalHeader>{'Редактирование типа продукции'}</PlainModalHeader>
      <PlainModalContent>
        <EditProductionTypeForm
          startValues={{ [FormControl.Name]: saleTypeTarget.title }}
          onModify={setModify}
        />
      </PlainModalContent>
      <PlainModalFooter>
        {handleModalDisplayed => (
          <ControlsBar right>
            <PlainButton
              type="submit"
              disabled={submitting || !modify}
            >
              {submitting ? 'Сохранение...' : 'Сохранить'}
            </PlainButton>

            <PlainButton
              outline
              onClick={handleModalDisplayed}
            >
              {'Отмена'}
            </PlainButton>
          </ControlsBar>
        )}
      </PlainModalFooter>
    </PlainModal>
  )
}
